import React, { useMemo } from "react";
import { useSpaceQuery } from "../../../Helpers/IOClient";
import KeyedDropdown from "../../Dropdown/KeyedDropdown";
import { AccountProfileImg } from "../../Img/Img";

export const AlgDevRepositoryValueComponent = ({ item, size, className }) => {
  if (!item || item.Id === null) {
    return (
      <span className="fs-14 fw-regular" style={{ color: "#7C98B6" }}>
        &nbsp;
      </span>
    );
  }
  return (
    <div className="align-items-center d-flex of-hidden w-100">
      <AccountProfileImg
        circular
        size={size ? size : "mds"}
        account={{
          Image: `${item.Avatar}`,
          Name: item.Name ? item.Name.split("@")[0].replace(".", " ") : "",
        }}
      />
      <div className="align-items-center d-flex flex-1 flex-md-shrink-1 justify-content-between ml-2 of-hidden w-100 w-fit">
        <div className="flex-1 text-truncate pr-2">
          <div
            className={className ? className : "text-truncate fs-14 fw-regular"}
          >
            {item.Name}
          </div>
        </div>
      </div>
    </div>
  );
};
const EMPTY_COLLECTION = { Id: null, Name: "N/A" };
const AlgDevRepositoryDropdown = ({ collection, project, ...props }) => {
  const resolvedUrl = useMemo(() => {
    if (collection && project) {
      return `Integrations/Devops/Query/${collection}/${project}/Repositories`;
    } else return null;
  }, [collection, project]);

  const { data, loading } = useSpaceQuery(resolvedUrl, null, {
    cache: false,
  });

  const options = useMemo(() => {
    const items = !loading && Array.isArray(data) ? data : [];
    if (items.length > 0) return [EMPTY_COLLECTION, ...items];
    else return [EMPTY_COLLECTION];
  }, [data, loading]);

  return (
    <KeyedDropdown
      options={options}
      valueComponent={AlgDevRepositoryValueComponent}
      getKey={(e) => (e.Id === null ? "empty" : e.Id)}
      closeOnSelect
      {...props}
      disabled={loading || (Array.isArray(data) && data.length === 0)}
    />
  );
};

export default AlgDevRepositoryDropdown;
